import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=46d6107c"
import script from "./Blank.vue?vue&type=script&lang=ts"
export * from "./Blank.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports